import { axios } from "..";
import type { IHelpCenter } from "../interfaces/models/IHelpCenter";
import { normalizeHelpCenterConfig } from "../pages/HelpCenter/helpCenterUtils";

let cachedConfig: IHelpCenter | null = null;
let inflightRequest: Promise<IHelpCenter> | null = null;

export function getCachedHelpCenter(): IHelpCenter | null {
  return cachedConfig;
}

export async function getHelpCenter(): Promise<IHelpCenter> {
  if (cachedConfig) {
    return cachedConfig;
  }

  if (!inflightRequest) {
    inflightRequest = axios
      .Get("/helpCenter")
      .then((response) => {
        const normalized = normalizeHelpCenterConfig(response.data);
        cachedConfig = normalized;
        return normalized;
      })
      .finally(() => {
        inflightRequest = null;
      });
  }

  return inflightRequest;
}

export async function updateHelpCenter(
  payload: IHelpCenter,
): Promise<IHelpCenter> {
  const response = await axios.Put("/helpCenter", normalizeHelpCenterConfig(payload));
  cachedConfig = normalizeHelpCenterConfig(response.data);
  return cachedConfig;
}
